module.exports = __webpack_public_path__ + "img/The-Good-Gateway-Green-09.2e9258c7.jpg";